import React from "react";
import { motion } from "framer-motion";
import YachtBookingForm from "../YachtBookingForm/YachtBookingForm";
import BgImage from "../../assets/images/seascape-experiences-mykonos-greece-cyclades-fleet-rental-charter-vertigo-sr-rib-boat-1109.jpg";
import Header from "../Header/Header";

const Hero = () => {
  return (
    <section className="relative bg-cover bg-center min-h-[90vh] md:h-[90vh] overflow-y-hidden" style={{ backgroundImage: `url(${BgImage})` }}>

      <motion.div 
        className="relative text-center z-10 text-white p-4 sm:p-10 w-full mx-auto h-full items-center JosefinSans overflow-y-hidden"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >

        <YachtBookingForm />
      </motion.div>
    </section>
  );
};

export default Hero;